import {
  setSearchCriteria,
  setLoading4Home,
  setUserListItem,
  setVerseReadLogList4Book,
  setSearchTabNumber,
  //setFontSize,
  setBookChapter,
  setBookList,
  setAnchorEl2,
  setConfirmedTabNumber,
  //setNoteVisible,
  setOpen2,
  //setOpen4, 
  //setSearchVisible, 
  reset4Home,
  // setConfirmedBookChapterList,
  setViewArea,
  setCircularProgressText,
} from '../Redux/homeReducer';

import { 
  setTitle,
  setTitleClearButton,
  setLengthIndicator4Title,
  setDetails,
  setLengthIndicator4Details,
  setNoteBookmarkListItemToBeChanged,
  reset4Dialog4,
  setTab4AddChange,
  setButtonTextDialog4,
} from '../Redux/dialog4Reducer';

import { 
  setBook4Accordion1,
  setChapter4Accordion1,
  setVerse4Accordion1,
  setBookChapter2,
  setBookChapterList2,
  setVerseList4Accordion1,
  setNoteBookmarkVerseList,
  //setLoading4Accordion1,
  reset4NoteBookmarkVerseList,
} from '../Redux/noteBookmarkVerseListReducer';

import { 
  setBookListItemSelected,
  reset4Book,
} from '../Redux/bookReducer';

import { 
  setBookChapterList, 
  setBookChapterListItemSelected,
  setOpen1,
  reset4Chapter,
} from '../Redux/chapterReducer';

import { 
  setSearchString, 
  setConfirmedSearchString, 
  setNonSearchString1, 
  setNonSearchString2, 
  setSearchStringClearButton, 
  setNonSearchStringClearButton, 
  setSearchScopeList, 
  setSearchScopeListItemSelected, 
  //setChipData, 
  setShowRemaining, 
  setSearchCriteriaListItem, 
  setSearchResultVerseList, 
  setPageNumber, 
  setPageSize, 
  setSearchHttpPostData, 
  //setLoading4Search,
  setOpen3,
  setPageNumberVerseSearch,
  setSearchStringPlaceHolder,
  setNonSearchString1PlaceHolder,
  setNonSearchString2PlaceHolder,
  setVerseListItem,
  reset4Search,
 } from '../Redux/verseSearchReducer';

import { 
    setNoteBookmarkList,
    //setLoading4NoteBookmarkList,
    setNoteBookmarkListBookChapterVerse,
    setPageNumberNote,
    setPageNumberNoteSearch,
    reset4NoteBookmarkList,
    setCaller4NoteBookmarkList,
} from '../Redux/noteBookmarkListReducer';

import { 
  setLoading, 
  setHistoryList, 
  setHistoryListItemSelected, 
  setHistoryBookChapter,
  reset4Dialog2,
} from '../Redux/dialog2Reducer';

import { 
  //New
  setTabVerseListNew, 
  //setSelectedVerses,
  //
  reset4Verse,
} from '../Redux/verseReducer';

import { 
  setOpenConfirmationDialog,
  // setRecordToBeDeleted,
  setTitleToBeDeleted,
  setCallerConfirmationDialog,
  reset4ConfirmationDialog,
  setNoteBookmarkListItemToBeDeleted,
  setDialogTitle,
  setButtonText,
} from '../Redux/confirmationDialogReducer';

import { 
  setShowLeftArrowVerseSearch, 
  setShowRightArrowVerseSearch, 
  setShowfabContentVerseSearch,  
  setShowLeftArrowNote, 
  setShowRightArrowNote, 
  setShowfabContentNote,
  setShowLeftArrowNoteSearch, 
  setShowRightArrowNoteSearch, 
  setShowfabContentNoteSearch,  
  reset4verseLabelArrows4Result,
} from '../Redux/verseLabelArrows4ResultReducer';

import { 
  // setChecked,
  reset4Switch1,
} from '../Redux/switch1Reducer';

import { 
    setGoToTopButtonVisible,
    reset4GoToTopButtonVisible,
} from '../Redux/goToTopButtonReducer';

import { 
    setChipData,
    reset4ChipArray,
} from '../Redux/chipArrayReducer';

import { 
  setUsernameErrorMessage,
  setPasswordErrorMessage,
  setUsername,
  setPassword,
  setPasswordError,
  setUsernameError,
  //
  reset4SignIn,
  setCredential,
} from '../Redux/signInReducer';

import { 
  // setUserListItemToBeChanged, 
  // setUserListItemToBeAdded,
  setEmailExisted,
  setUsernameExisted,
  setLastNameOverMaxLength,
  setFirstNameOverMaxLength,
  reset4Profile,
  setBookReadLogToBeCleared,
} from '../Redux/profileReducer';

import { 
  setNoteSearchString,
  setConfirmedNoteSearchString,
  setNoteSearchStringClearButton,
  setShowRemainingNoteSearch,
  setSearchCriteriaListItem2,
  setSearchResultVerseList2,
  setVerseListItem2,
  setNoteSearchStringPlaceHolder,
  reset4NoteSearch,
} from '../Redux/noteSearchReducer';

export default { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile };